import { state } from '../../../context/store'
import { Button, Heading, Row, Column } from '../../Blocks'
import { closePopups, resetAllDesigns, resetModel } from '../../../utilities'
import { useSnapshot } from 'valtio'

const ModalResetCustomisation = ({ id }) => {
  const snap = useSnapshot(state.current)

  const resettingDesign = (e) => {
    resetAllDesigns()
    closePopups(e)
    state.current.status.confirmResetDesign = false
  }
  const resettingModel = (e) => {
    closePopups(e)
    state.current.status.confirmResetModel = false
    resetModel()
  }

  //   console.log('satte', state.status.confirmResetDesign)
  //   console.log('snap', state.status.confirmResetDesign)
  return (
    <Column id={id}>
      <Heading>
        {snap.status.confirmResetDesign
          ? 'Confirm reset'
          : 'Reset your previous choices?'}
      </Heading>

      {snap.status.confirmResetDesign ? (
        <Row justify="center" gap="12px">
          <Button
            accent
            handleClick={(e) => {
              resettingDesign(e)
            }}
          >
            Confirm Reset
          </Button>

          <Button handleClick={(e) => closePopups(e)}>Cancel</Button>
        </Row>
      ) : (
        <Row justify="center" gap="12px">
          <Button handleClick={() => (state.current.status.confirmResetDesign = true)}>
            Reset Choices
          </Button>
          <Button handleClick={(e) => closePopups(e)}>Go Back</Button>
        </Row>
      )}
      <Heading>
        {snap.status.confirmResetModel ? 'Confirm reset' : 'Reset your previous choices?'}
      </Heading>

      {snap.status.confirmResetModel ? (
        <Row justify="center" gap="12px">
          <Button
            accent
            handleClick={(e) => {
              resettingModel(e)
            }}
          >
            Confirm Reset
          </Button>

          <Button handleClick={(e) => closePopups(e)}>Cancel</Button>
        </Row>
      ) : (
        <Row justify="center" gap="12px">
          <Button handleClick={() => (state.current.status.confirmResetModel = true)}>
            Pick Another Seat
          </Button>
          <Button handleClick={(e) => closePopups(e)}>Go Back</Button>
        </Row>
      )}
    </Column>
  )
}

export default ModalResetCustomisation
